import React, { useEffect, useRef } from 'react';
import styles from './Me.module.css';
import tali from '../../images/אני copy.webp';

const AboutMe = () => {
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    const phoneNumber = '+972544493213';
    const message = 'היי טלי, הגעתי מהדף שלך. אשמח לשמוע עוד על תהליך העבודה שלך.';
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, '_blank');
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.2 }
    );

    const revealElements = containerRef.current.querySelectorAll(`.${styles.revealItem}`);
    revealElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 1s ease, transform 1s ease';
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={containerRef} className={styles.section} id="מי-אני">
      <div className={styles.container}>
        <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
          <img src={tali} alt="טלי אטיה" className={styles.image} loading="lazy" />
        </div>

        <div className={`${styles.content} ${styles.revealItem}`}>
          <h2 className={styles.mainTitle}>נעים להכיר,</h2>

          <div className={styles.textBlock}>
            <p className={styles.paragraph}>
              אני טלי אטיה, מעצבת פנים ובעלת סטודיו המתמחה בעיצוב חללי מגורים בהתאמה אישית. בעלת ניסיון רב בליווי תהליכי עיצוב פנים ותכנון, הלבשת בתים, השבחת נכסים ודירות קבלן. עם וותק בעשרות פרויקטים מרתקים הן בארץ והן בחו"ל.
            </p>

            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              התשוקה שלי היא ליצור חללים שמשלבים אסתטיקה ופונקציונליות תוך התאמה לצרכים, לתקציב ולסגנון החיים הייחודי של כל לקוח.
            </p>

            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              במהלך השנים פיתחתי סגנון עבודה המתמקד בתכנון קפדני, חשיבה יצירתית על הפרטים הקטנים ושימוש בחומרים חדשניים כדי להביא לידי ביטוי את החזון של לקוחותיי
            </p>

            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אני מאמינה שעיצוב טוב צריך לא רק להיות מרהיב מבחינה ויזואלית, אלא גם לגרום לחלל להרגיש כמו בית, מקום של נוחות והרמוניה.
            </p>

            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              עיצוב פנים מותאם משפר את איכות החיים של בני הבית, משרה שלווה פנימית ומשפיע לטובה על מצב הרוח והאנרגיה - והתפקיד שלי הוא לתרגם את מי שאתם לשפה עיצובית - שתראה יפה, אבל גם תרגיש נכון
            </p>

            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אני חיה, נושמת ואוהבת עיצוב ואסתטיקה ונהנית מהדינמיקה וסיעור המוחות שיש לתחום הזה להציע. כל פרויקט עבורי מתחיל בהקשבה עמוקה ללקוחות והופך למסע יצירתי ומרגש שבו אנו בונים יחד, יד ביד את החלל המושלם והמותאם במיוחד עבורם, משלב החלום ועד חנוכת הבית.
            </p>

            <div className={styles.divider}></div>

            <p className={styles.finalText}>
              מזמינה אתכם לצאת איתי יחד למסע שיעצב לא רק את הבית - אלא גם את היומיום שלכם
            </p>
          </div>

          <button className={styles.ctaButton} onClick={handleButtonClick}>
            לחצו כאן לשיחת ייעוץ ללא עלות
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;